import { useHistory } from "react-router";
import { consts } from "../../common/consts";
import { RootState } from "../../store/rootReducer";
import { useSelector } from "react-redux";

const useRedirect = () => {
  const history = useHistory();

  const { authStore } = useSelector((state: RootState) => state);

  const redirectToNext = () => {
    console.log(consts.Permissions.ViewDashboard);
    var permissions = authStore.data?.role.split(",");
    if (permissions) {
      if (
        permissions.indexOf(consts.Permissions.ViewDashboard) > 0 ||
        permissions.indexOf(
          consts.Permissions.SMAAdminPatientTransportDashboard
        ) > 0
      ) {
        history.push("/dashboard");
      } else if (permissions.includes(consts.Permissions.RequestCallout)) {
        history.push("/requestcallout");
      }
      //else if (permissions.includes(consts.Permissions.SMAMakeBooking) || permissions.includes(consts.Permissions.makeBooking)  || permissions.includes("")) {
      //    if (permissions.includes(consts.Permissions.SMAMakeBooking) || permissions.includes(consts.Permissions.makeBooking)){
      //        setdisableBooking(false);
      //    }
      //    // Redirect to Landing page
      //   history.push('/');
      //}
      else if (
        permissions.includes(consts.Permissions.ManageCustomerVehicles) &&
        permissions.indexOf(consts.Permissions.ViewSchedule) === -1 &&
        permissions.indexOf(consts.Permissions.SMAViewSchedule) === -1 &&
        authStore?.data?.IsAdmin === false
      ) {
        history.push("/managevehicles");
      } else if (
        permissions.includes(consts.Permissions.ViewCustomerTransferHistory) &&
        permissions.indexOf(consts.Permissions.ViewSchedule) === -1 &&
        permissions.indexOf(consts.Permissions.SMAViewSchedule) === -1 &&
        authStore?.data?.IsAdmin === false
      ) {
        history.push("/transfers/0");
      } else if (
        permissions.includes(consts.Permissions.SMAAdminManageUsers) &&
        permissions.indexOf(consts.Permissions.ViewSchedule) === -1 &&
        permissions.indexOf(consts.Permissions.SMAViewSchedule) === -1 &&
        authStore?.data?.IsAdmin === false
      ) {
        history.push("/settings/users");
      } else if (
        permissions.includes(consts.Permissions.SMAAdminManageUserprofiles) &&
        permissions.indexOf(consts.Permissions.ViewSchedule) === -1 &&
        permissions.indexOf(consts.Permissions.SMAViewSchedule) === -1 &&
        authStore?.data?.IsAdmin === false
      ) {
        history.push("/settings/profiles");
      } else if (
        permissions.includes(consts.Permissions.ManageUsers) &&
        permissions.indexOf(consts.Permissions.ViewSchedule) === -1 &&
        permissions.indexOf(consts.Permissions.SMAViewSchedule) === -1 &&
        authStore?.data?.IsAdmin === false
      ) {
        history.push("/manageusers");
      } else if (
        permissions.includes(consts.Permissions.ViewPCR) &&
        permissions.indexOf(consts.Permissions.ViewSchedule) === -1 &&
        permissions.indexOf(consts.Permissions.SMAViewSchedule) === -1 &&
        authStore?.data?.IsAdmin === false
      ) {
        history.push("/patientCareRecord/viewpcr");
      } else if (
        permissions.includes(consts.Permissions.SMASubmitPatientCareRecords) &&
        permissions.indexOf(consts.Permissions.ViewSchedule) === -1 &&
        permissions.indexOf(consts.Permissions.SMAViewSchedule) === -1 &&
        authStore?.data?.IsAdmin === false
      ) {
        history.push("/patientCareRecord");
      } else if (
        permissions.includes(consts.Permissions.SubmitPatientCareRecord) &&
        permissions.indexOf(consts.Permissions.ViewSchedule) === -1 &&
        permissions.indexOf(consts.Permissions.SMAViewSchedule) === -1 &&
        authStore?.data?.IsAdmin === false
      ) {
        history.push("/patientCareRecord");
      } else {
        history.push("/transferschedule");
      }
    }
  };

  return { redirectToNext };
};

export default useRedirect;
